document.addEventListener("DOMContentLoaded", () => {
  class BrandList extends HTMLElement {
    constructor() {
      super();
      this.unorderedList = this.querySelector("ul");
      if (this.unorderedList) {
        this.sortList();
      }
    }

    sortList() {
      if (!this.unorderedList) return;

      const items = Array.from(this.unorderedList.querySelectorAll("li"));
      items.sort((a, b) => a.textContent.localeCompare(b.textContent));

      // Use DocumentFragment to avoid multiple reflows
      const fragment = document.createDocumentFragment();
      items.forEach((item) => fragment.appendChild(item));

      // Replace the entire list content with sorted items
      this.unorderedList.innerHTML = "";
      this.unorderedList.appendChild(fragment);
    }
  }

  customElements.define("brand-list", BrandList);
});
